import React, { useState, useEffect, useContext } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { login } from '../../Services/Authentication.Serivice';
import Logo from '../../Assets/images/logo.png';
import Banner from '../../Assets/images/banner.jpg';
import Toaster from '../../Components/Toaster';
import TokenService from "../../Services/Token.service";
import { GlobalInfo } from '../../Contexts/GlobalContext';

function Login({ setIsLoggedIn }) {   

    
    const navigate = useNavigate();
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState(''); // 'success' or 'error'
    const dirPath = process.env.REACT_APP_SUB_DIR;
    
    const handleForgotPassword = () => {
        navigate("/forgotpassword");
    };

    const { updateUserDetails } = useContext(GlobalInfo); 
    const validationSchema = Yup.object({
        username: Yup.string()
            .matches(/^\S*$/, 'No spaces are allowed')
            .max(50, 'User Name or Email must not be more than 50 characters')
            // .email('Invalid email address')
            // .matches(/^[^@\s]+@[^@\s]+\.[^@\s]+$/, 'Invalid email address')
            .required('User name or Email is required'),
        password: Yup.string()
            .min(8, 'Password must be at least 8 characters')
            .max(20, 'Password must not be more than 20 characters')
            .required('Password is required'),
    });

    function getNavigationPath(slug) {
        const routes = {
            "admin-controls": "sample-requests",
            "donor-controls": "job-board",
            "requestor-controls": "requestor-sample-requests",
            "profile-management": "profile-management",
        }; 
        // Return the mapped route or the original slug if no match is found
        return routes[slug] || slug;
    }
    const handleSubmit = (values, { setSubmitting }) => {
        login(values)
            .then(response => {
                if (response.status === false) {
                    setToastMessage(response.error || "Something went wrong");
                    setShowToast(true);
                    setToastVariant('error');
                    return;
                }
                updateUserDetails(response); 
                TokenService.setUser(response); 
                setIsLoggedIn(true);
                
                const role = response.roles.find((r) => r.toLowerCase() === "superadmin");
                if (role) {                    
                    navigate(`/admin/sample-requests`);
                    TokenService.updatePrevLink('/admin/sample-requests');
                } else { 
                    
                    // Navigate to the respective role's page
                    const currentRole = response.roles[0]?.toLowerCase(); // Default to the first role if no "Superadmin" is found
                    const slug = response.menus[0].slug;
                    const navigationPath = getNavigationPath(slug);

                    if (navigationPath === "profile-management") {
                        navigate(`/profile-management/profile-settings`);
                        
                    } else {
                        navigate(`/${currentRole}/${response.menus[0].children[0].slug}`);
                        TokenService.updatePrevLink(`/${currentRole}/${response.menus[0].children[0].slug}`);

                    }
                }

            })
            .catch(error => {
                setToastMessage(error.response?.data?.error || "Something went wrong");
                setShowToast(true);
                setToastVariant('error');
            })
            .finally(() => {
                setSubmitting(false);
            });
    };    

    return (
        <>
            <main className="d-flex align-items-center bg-white" style={{ background: `url(${Banner}) left center no-repeat`, backgroundSize: 'cover' }}>
                <section className="el-login-sec w-100">
                    <div className="ml-auto d-block">
                        <div className="el-login-background d-block box-shadow-none">
                            <div className="el-login-card ml-lg-auto d-block">
                                <div className="el-login-logo">
                                    <img src={Logo} className="img-fluid logindonar-x-logo" alt="donor x" />
                                </div>
                                <h2>Hi, 👋 <br /> Welcome to Donor X</h2>
                                <div className="el-login-form">
                                    <Formik
                                        initialValues={{ username: '', password: '' }}
                                        validationSchema={validationSchema}
                                        validateOnBlur={false} 
                                        validateOnChange={true} 
                                        onSubmit={handleSubmit}
                                    >
                                        {({ isSubmitting }) => (
                                            <Form>
                                                <div className="el-form-group mb-3">
                                                    <label htmlFor="username" className="form-label">User Name or Email<span className="text-red">*</span></label>
                                                    <Field
                                                        type="text"
                                                        className="form-control"
                                                        // placeholder="User name"
                                                        id="username"
                                                        name="username"
                                                    />
                                                    <ErrorMessage name="username" component="div" className="text-danger" />
                                                </div>
                                                <div className="el-form-group mb-3">
                                                    <label htmlFor="password" className="form-label">Password<span className="text-red">*</span></label>
                                                    <Field
                                                        type="password"
                                                        className="form-control"
                                                        // placeholder="Password"
                                                        id="password"
                                                        name="password"
                                                        maxLength = {20}
                                                    />
                                                    <ErrorMessage name="password" component="div" className="text-danger" />
                                                </div>
                                                <a onClick={handleForgotPassword} className="elfotget-password el-text-dark">Forget Password?</a>
                                                <div className="el-form-btn-submit">
                                                    <button type="submit" className="el-btn-primary" disabled={isSubmitting}>
                                                        {isSubmitting ? 'Logging in...' : 'Login Now'}
                                                    </button>
                                                </div>
                                                
                                                {/* <div className="el-form-link text-center">                                                    
                                                    Don’t have an account yet? <b><a onClick={() => { navigate('/signup') }} className="elfotget-password el-text-dark">Register your account</a></b>
                                                </div> */}
                                            </Form>
                                        )}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            {/* Reusable Toaster */}
            <Toaster
                show={showToast}
                message={toastMessage}
                variant={toastVariant}
                onClose={() => setShowToast(false)}
            />
        </>
    );
}

export default Login;
